'use client';

import React, { FC, useCallback, useContext } from 'react';
import { Dialog, DialogContent } from 'components/ui/dialog';
import { Sheet, SheetContent } from 'components/ui/sheet';
import { useMedia } from 'react-use';
import { CommunitiesQuery } from 'generated/operations';
import { ApplyForm } from 'app/(unauthenticated)/apply/ApplyForm';
import { useRouter } from 'next/navigation';
import { MEMBER_ROUTES } from 'utils/routes';
import { useCommunity } from 'contexts/communityApp';
import ApplyLoginContext from 'app/_context/ApplyLoginContext';

type CommunitiesNode = CommunitiesQuery['communities']['objs'][number];

interface ApplyFormDialogProps {
  community: CommunitiesNode;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const ApplyFormDialog: FC<ApplyFormDialogProps> = ({
  community,
  open,
  onOpenChange,
}) => {


  const isMobile = useMedia('(max-width: 768px)', false);
  const router = useRouter();
  const { chooseCommunity } = useCommunity();

  const DialogRoot = isMobile ? Sheet : Dialog;
  const Content = isMobile ? SheetContent : DialogContent;

  const onJoin = useCallback(()  => {
    chooseCommunity(community);
    router.push(MEMBER_ROUTES.SPACE.getPath(community.subdomain || community.domain || community.id));
  }, [chooseCommunity, community, router])

  return (
    <DialogRoot open={open} onOpenChange={onOpenChange}>
      <Content className='p-0 bg-white md:!max-w-full md:!w-full md:h-full'>
        <ApplyForm
          landingFields={community.landing?.applicationFields ?? []}
          community={community}
          onJoin={onJoin}
        />
      </Content>
    </DialogRoot>
  );
};
